var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{key:_vm.componentKey}),_c('div',{staticClass:"maximum-width"},[_c('link-index')],1),_c('footer-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }